import { render, staticRenderFns } from "./SQuesFourteen.vue?vue&type=template&id=1a4ff73e&"
import script from "./SQuesFourteen.vue?vue&type=script&lang=js&"
export * from "./SQuesFourteen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports